/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: prepostroll-asset-service.ts
 *
 * Created by kyang on 10/21/20.
 */

// This service is an implementation for BrandingAssetService.
// Components should invoke the abstract BrandingAssetService, not this specific implementation.

angular.module('prism-ui.components.branding').service('PrePostRollAssetService', function (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    BrandingAssetService: JS5Object,
    BrandingViewService: JS5Object,
    MediaProfileResourceFactory: JS5Object,
    PrePostRollResourceFactory: JS5Object,
) {

    //==========================//
    // Branding Asset Container //
    //==========================//

    this.getBrandingAssetContainer = (containerId: string) => {
        return PrePostRollResourceFactory.get({containerId}).$promise;
    };

    this.parseBrandingAssetContainer = (brandingConfig: JS5Object, brandingAssetContainer: JS5Object) => {
        brandingAssetContainer.assets = BrandingAssetService.filterBrandingAssets(brandingConfig, brandingAssetContainer.assets, {anySeasonVolume: true});
    };

    this.updateBrandingAssetContainer = (brandingConfig: JS5Object, brandingAssetContainer: JS5Object) => {
        return PrePostRollResourceFactory.update({
            containerId: brandingAssetContainer.id
        }, brandingAssetContainer).$promise;
    };


    //=======//
    // Asset //
    //=======//

    const createEmptyRootBrandingAsset = (brandingConfig: JS5Object, acceptProfile: JS5Object) => {
        let rootAsset: JS5Object = {
            acceptProfile: acceptProfile,
            audios: [],
            texts: [],
        };
        if (brandingConfig.seasonId) {
            rootAsset.seasonId = brandingConfig.seasonId;
        } else if (brandingConfig.volumeId) {
            rootAsset.volumeId = brandingConfig.volumeId;
        }
        return rootAsset;
    };

    this.getRootBrandingAsset = (brandingConfig: JS5Object, container: JS5Object, acceptProfile: JS5Object) => {
        let videoAssets = BrandingAssetService.filterBrandingAssets(brandingConfig, container.assets);
        let rootAsset = _.find(videoAssets, {
            acceptProfile: {id: acceptProfile.id}
        });
        if (rootAsset) {
            rootAsset.audios = _.get(rootAsset, 'audios', []);
            rootAsset.texts = _.get(rootAsset, 'texts', []);
            return rootAsset;
        }
        return createEmptyRootBrandingAsset(brandingConfig, acceptProfile);
    };

    this.validateNonTextAsset = (acceptProfileId: number, asset: JS5Object, virtualPath: string) => {
        return MediaProfileResourceFactory.validatePrePostRoll({
            path: virtualPath,
            profileId: acceptProfileId
        }).$promise.then((validationResult: JS5Object) => {
            return _.get(validationResult, `${acceptProfileId}.failures`);
        });
    };

    this.createRootBrandingAsset = (brandingConfig: JS5Object, rootAsset: JS5Object) => {
        return PrePostRollResourceFactory.createAsset({containerId: brandingConfig.id}, rootAsset).$promise;
    };

    this.updateRootBrandingAsset = (brandingConfig: JS5Object, rootAsset: JS5Object) => {
        return PrePostRollResourceFactory.updateAsset({assetId: rootAsset.id}, rootAsset).$promise;
    };


    //=========//
    // Proxies //
    //=========//

    this.hasVideoAssetProxyStatus = (brandingConfig: JS5Object, rootAsset: JS5Object) => {
        return !BrandingAssetService.assetWasIngested(rootAsset);
    };

    this.updateVideoAssetProxyStatus = (brandingConfig: JS5Object, rootAsset: JS5Object, intervalData: JS5Object) => {
        return PrePostRollResourceFactory.getAsset({assetId: rootAsset.id}).$promise
            .then((updatedRootAsset: JS5Object) => {
                let status = BrandingAssetService.ProxyStatus.PROXY_RUNNING;
                if (_.get(updatedRootAsset, 'proxyId')) {
                    status = BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
                } else if (_.get(updatedRootAsset, 'ingestInfo.workflowStatus') === BrandingAssetService.ProxyStatus.PROXY_STALLED) {
                    status = BrandingAssetService.ProxyStatus.PROXY_STALLED;
                }
                BrandingViewService.showVideoIngestStatusNotifications(brandingConfig, updatedRootAsset, status, '');
                return status;
            });
    };
});


//=================//
// Lifecycle Hooks //
//=================//

// Load this service when app is initialized
angular.module('prism-ui.components.branding').run((
    BrandingAssetService: JS5Object,
    PrePostRollAssetService: JS5Object,
) => {
    BrandingAssetService.registerAssetServiceImplementation('preRolls', PrePostRollAssetService);
    BrandingAssetService.registerAssetServiceImplementation('postRolls', PrePostRollAssetService);
});
